<template>
	<div id="cloudCenter">
		<heads></heads>
		<div class="left_t_box">
			<div class="modular_title modular_title_lw">
				<img src="../../assets/tit_icon.png" />
				<div>
					实时水位监测数据与水位上限下限
				</div>
			</div>
			<div id="history">

			</div>
		</div>
		<div class="right_t_box">
			<div class="modular_title modular_title_lw">
				<img src="../../assets/tit_icon.png" />
				<div>
					
					水位监测实时数据
				</div>
			</div>
			<div id="realtime">

			</div>
		</div>
		<div class="bottom_box">
			<div class="modular_title modular_title_lw">
				<img src="../../assets/tit_icon.png" />
				<div>
					
					水位监测历史数据
				</div>
			</div>
			<div class="block">
				<span class="demonstration">默认</span>
				<el-date-picker v-model="value" @change="change" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</div>
			<div id="historylevel">

			</div>
		</div>
	</div>
</template>

<script>
	import heads from "@/components/header.vue"
	import * as echarts from 'echarts';
	export default {
		data() {
			return {
				value:''
			}
		},
		components: {
			heads,
		},
		mounted() {
			this.history()
			this.realtime()
			this.historylevel()
			this.resetScreenSize()
		},
		methods: {
			change(val){
				console.log(this.value)
			},
			historylevel() {
				let myChart = echarts.init(document.getElementById('historylevel'));
				let option = {
					tooltip: {
						trigger: "axis",
					},
					color: ["#5DC2F9", "#F5CB3B"],
					grid: {
						right: "8%",
						left: "8%",
						top: '20%',
						bottom: '20%'
					},
					legend: {
						icon: "circle",
						bottom: '6%',
						left: 20,
						textStyle: {
							color: "#ffffff",
						},
					},
					xAxis: {

						type: 'category',
						axisLine: {
							show: true,
							color: '#A3E9FC'
						},

						axisLabel: {
							color: '#fffff',
							width: 100,
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ffffff',
								opacity: 0.2
							}
						},
						data: ['02:33', '03:33', '04:33', '05:33', '05:33', '05:33'],
					},
					yAxis: {
						type: 'value',
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ffffff',
								opacity: 0.2
							}
						},
						boundaryGap: true,
						axisLine: {
							show: true,
							color: 'A3E9FC'
						},
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: '#ffffff'
							}
						},
						axisTick: {
							show: false
						}
					},
					series: [{
						name: "水位监测值",
						type: "line",
						markLine: { //最大值和最小值
							data: [{
									name: '水位上限30',
									yAxis: 54,
									label: {
										show: 'true',
										position: 'end',
										formatter: '水位上限30',
										color: '#7BF7AB'
									},
									lineStyle: {
										normal: {
											width: 2,
											color: "#7BF7AB",
										}
									}

								},
								{
									name: '水位下限20',
									yAxis: 44,
									label: {
										show: 'true',
										position: 'end',
										formatter: '水位下限20',
										color: '#E8556D'
									},
									lineStyle: {
										normal: {
											width: 2,
											color: "#E8556D",
										}
									}

								},
							]
						},
						smooth: true, //平滑曲线显示
						showAllSymbol: true, //显示所有图形。
						symbol: "circle", //标记的图形为实心圆
						symbolSize: 10, //标记的大小
						itemStyle: {
							//折线拐点标志的样式
							color: "#64C9F0"
						},
						lineStyle: {
							color: "#64C9F0"
						},
						data: [122, 208, 348, 450, 580]
					}, ]
				};
				myChart.setOption(option)
			},
			realtime() {
				
				let myChart = echarts.init(document.getElementById('realtime'));
				let option = {
					title: [{
							text: '水位上限：-4.80m',
							left: '240',
							top: '10%',
							textStyle: {
								color: '#7BF7AB',
								fontSize: 16,
							}
						},
						{
							text: '水位下限：-7.80m',
							left: '10',
							top: '10%',
							textStyle: {
								color: "#E8556D",
								fontSize: 16
							}
						}
					],
					tooltip: {
						trigger: "axis",
					},
					grid: {
						right: "20%",
						left: "20%",
						top: '20%',
						bottom: '20%'
					},
					legend: {
						icon: "circle",
						bottom: '6%',
						left: 20,
						textStyle: {
							color: "#ffffff",
						},
						data: ['总数']
					},
					xAxis: {

						type: 'category',
						axisLine: {
							show: true,
							color: '#A3E9FC'
						},

						axisLabel: {
							color: '#fffff',
							width: 100,
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ffffff',
								opacity: 0.2
							}
						},
						data: ['液位'],
					},
					yAxis: {
						type: 'value',
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ffffff',
								opacity: 0.2
							}
						},
						boundaryGap: true,
						axisLine: {
							show: true,
							color: 'A3E9FC'
						},
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: '#ffffff'
							}
						},
						axisTick: {
							show: false
						}
					},
					series: [

						//数据低下的圆片
						{
							name: "",
							type: "pictorialBar",
							symbolSize: [120, 25],
							symbolOffset: [0, 1],
							z: 12,
							itemStyle: {
								opacity: 1,
								color: '#5DC2F9'
							},
							data: [1]
						},
						//数据的柱状图
						{
							name: '总数',
							type: 'bar',
							markLine: { //最大值和最小值
								data: [{
										name: '水位上限30',
										yAxis: 54,
										label: {
											show: 'true',
											position: 'end',
											formatter: '水位上限30',
											color: '#7BF7AB'
										},
										lineStyle: {
											normal: {
												width: 2,
												color: "#7BF7AB",
											}
										}

									},
									{
										name: '水位下限20',
										yAxis: 44,
										label: {
											show: 'true',
											position: 'end',
											formatter: '水位下限20',
											color: '#E8556D'
										},
										lineStyle: {
											normal: {
												width: 2,
												color: "#E8556D",
											}
										}

									},
								]
							},
							barWidth: 120,
							barGap: '-100%',
							itemStyle: { //lenged文本
								opacity: 0.5, //这个是 透明度
								color: '#5DC2F9'
							},

							data: [40]
						},

						//数据顶部的样式
						{
							name: "",
							type: "pictorialBar",
							symbolSize: [120, 25],
							symbolOffset: [0, -10],
							z: 12,
							itemStyle: {
								opacity: 1,
								color: '#5DC2F9'
							},
							symbolPosition: "end",
							data: [40]
						},

						//阴影的顶部
						{
							name: "", //头部
							type: "pictorialBar",
							symbolSize: [120, 25],
							symbolOffset: [0, -10],
							z: 12,
							symbolPosition: "end",
							itemStyle: {
								opacity: 1,
								color: '#5DC2F9'
							},
							data: [100]
						},
						//后面的背景
						{
							name: '',
							type: 'bar',
							barWidth: 120,
							barGap: '-100%',
							z: 0,
							itemStyle: {
								opacity: 0.3,
								color: '#5DC2F9'
							},

							data: [100]
						}

					]
				};
				myChart.setOption(option)
			},
			//实时水位监测数据与水位上限下限
			history() {
				let color= ["#5DC2F9"]
				let myChart = echarts.init(document.getElementById('history'));
				let option = {
					title: [{
							text: '水位上限：-4.80m',
							left: '240',
							top: '10%',
							textStyle: {
								color: '#7BF7AB',
								fontSize: 16,
							}
						},
						{
							text: '水位下限：-7.80m',
							left: '10',
							top: '10%',
							textStyle: {
								color: "#E8556D",
								fontSize: 16
							}
						}
					],
					tooltip: {
						trigger: "axis",
					},
					color:color,
					grid: {
						right: "8%",
						left: "8%",
						top: '20%',
						bottom: '20%'
					},
					legend: {
						icon: "circle",
						bottom: '6%',
						left: 20,
						textStyle: {
							color: "#ffffff",
						},
					},
					xAxis: {

						type: 'category',
						axisLine: {
							show: true,
							color: '#A3E9FC'
						},

						axisLabel: {
							color: '#fffff',
							width: 100,
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ffffff',
								opacity: 0.2
							}
						},
						data: ['02:33', '03:33', '04:33', '05:33', '05:33', '05:33'],
					},
					yAxis: {
						type: 'value',
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ffffff',
								opacity: 0.2
							}
						},
						boundaryGap: true,
						axisLine: {
							show: true,
							color: 'A3E9FC'
						},
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: '#ffffff'
							}
						},
						axisTick: {
							show: false
						}
					},
					series: [{
						name: '水位监测值',
						type: 'bar',
						barWidth: '20',
						markLine: { //最大值和最小值
							data: [{
									name: '水位上限30',
									yAxis: 54,
									label: {
										show: 'true',
										position: 'end',
										formatter: '水位上限30',
										color: '#7BF7AB'
									},
									lineStyle: {
										normal: {
											width: 2,
											color: "#7BF7AB",
										}
									}

								},
								{
									name: '水位下限20',
									yAxis: 44,
									label: {
										show: 'true',
										position: 'end',
										formatter: '水位下限20',
										color: '#E8556D'
									},
									lineStyle: {
										normal: {
											width: 2,
											color: "#E8556D",
										}
									}

								},
							]
						},
						itemStyle: {
							normal: {
								barBorderRadius: [12, 12, 0, 0],
							},
						},
						data: [23, 23, 4, 34, 54]
					}, ]
				};
				myChart.setOption(option)
			},
			resetScreenSize(dw, dh) {
				if(window.innerWidth > 1000) {
					function init() {
						var _el = document.getElementById('cloudCenter');
						var hScale = window.innerHeight / (dh || 1080);
						var wScale = window.innerWidth / (dw || 1920);
						_el.style.transform = 'scaleX(' + wScale + ') scaleY(' + hScale + ')'
					}
					var lazyFun;
					window.onresize = function() {
						clearTimeout(lazyFun);
						lazyFun = setTimeout(function() {
							init()
						}, 600)
					}
					init()
				}
			}
		}
	}
</script>

<style scoped>
	@import "./index.css";
	#cloudCenter {
		width: 1920px;
		height: 1080px;
		transform-origin: left top;
		position: relative;
	}
	.modular_title {
		display: flex;		
		padding: 0 10px 0 20px;		
		align-items: center;		
		font-size: 22px;
		color: #FFFFFF;		
		line-height: 52px;
	}	
	.modular_title div{
		height: 52px;
		display: inline-block;
		background: url(../../assets/tit_bg.png) no-repeat center bottom;
		background-size:100% 17px;
	}
	.modular_title img {
		margin-right: 9px;
		vertical-align: middle;
	}
	
	.left_t_box {
		width: 1377px;
		height: 463px;
		float: left;
		margin-left: 31px;
		margin-top: 23px;
	}
	
	#history {
		width: 1377px;
		height: 411px;
	}
	
	.right_t_box {
		width: 469px;
		height: 463px;
		float: left;
		margin-left: 19px;
		margin-top: 23px;
	}
	
	#realtime {
		width: 469px;
		height: 411px;
	}
	
	.bottom_box {
		width: 1865px;
		height: 460px;
		float: left;
		margin-left: 30px;
		margin-top: 18px;
	}
	
	#historylevel {
		width: 1865px;
		height: 368px;
		clear: both;
	}
	/deep/ .el-date-editor{
		background: none!important;
	}
	/deep/ .el-date-editor input{
		background: none!important;
		color: #fff!important;
	}
	/deep/.el-range-separator{
		color: #fff!important;
	}
	.block{
		float: right;
		width: 100;
		overflow: hidden;
		margin-top: 52px;
		margin-right: 40px;
	}
</style>